import FavoriteVehiclesDrawerContainer from './FavoriteVehiclesDrawerContainer'

export default FavoriteVehiclesDrawerContainer
